import PropertyDepreciation from 'models/propertyDepreciation.model';

type ReducerAction = {
  type?: string;
  [key: string]: any;
};

export type PropertyDepreciationState = {
  amount?: number;
  rate?: number;
  years?: number;
  [key: string]: any;
};

const initialState: PropertyDepreciationState =
  new PropertyDepreciation() as PropertyDepreciationState;

const propertyDepreciationReducer = (
  state: PropertyDepreciationState = initialState,
  action: ReducerAction
): PropertyDepreciationState => {
  switch (action.type) {
    case 'PROPERTY_DEPRECIATION_UPDATE': {
      const { depreciation } = action;
      return {
        ...state,
        ...depreciation,
      };
    }
    default:
      return state;
  }
};
export default propertyDepreciationReducer;
